import { useState, useEffect } from "react";
import { GetMocktestQuestion } from "../../../Client/request";

export const useListeningQuestion = (quest, startStopwatch) => {
  const [questData, setQuestData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      GetMocktestQuestion(quest.QuestionId).then((res) => {
        if (res.data) {
          setQuestData(res.data);
          setLoading(false);
          startStopwatch();
        }
      });
    }
    // eslint-disable-next-line
  }, [quest]); // startStopwatch intentionally omitted to prevent re-renders

  return {
    questData,
    loading,
    setQuestData,
  };
};
